import { size } from "../../../../../constants";
import { useWindowSize } from "../../../../../hooks/useWindowResize";
import { cn } from "../../../../../lib/utils";
import { Line } from "../../components/Line";
import { Subtitle } from "../../components/Subtitle";
import { Text } from "../../components/Text";
import { useTranslation } from "next-i18next";

export default function ChallengeSection() {
	const { width } = useWindowSize();
	const { t } = useTranslation();
	const isLaptop = width >= size.laptop;

	return (
		<section className="bg-neutral-07">
			<div className="relative container-blog">
				<Line className="border-[#398BE3]" />

				<Subtitle>
					<h2>{t("products.brinks.challenge.title")}</h2>
				</Subtitle>

				<div className="flex justify-between laptop:gap-6">
					<div className="laptop:max-w-[600px] w-full z-10">
						<Text className="text-left laptop:text-justify">
							{t("products.brinks.challenge.description1.part1")}
							<strong className="font-semibold text-white">
								{t("products.brinks.challenge.description1.company")}
							</strong>
							{t("products.brinks.challenge.description1.part2")}{" "}
							<span className="font-semibold text-[#398BE3]">
								{t("products.brinks.challenge.description1.highlight")}
							</span>
							{t("products.brinks.challenge.description1.part3")}
						</Text>

						{!isLaptop && (
							<div className="flex relative w-full my-8 max-w-[420px] mx-auto">
								<img
									src={"/landings/assets/images/casos/assets/brinks/brinks-mockup-mobile.svg"}
									alt=""
									className={cn("z-10 w-full")}
								/>
							</div>
						)}

						<Text className="text-left laptop:text-justify laptop:mt-8">
							{t("products.brinks.challenge.description2")}{" "}
							<span className="font-semibold text-[#398BE3]">
								{t("products.brinks.challenge.highlight2")}
							</span>
							{t("products.brinks.challenge.part3")}
						</Text>
					</div>

					{isLaptop && (
						<div className="flex relative w-full laptopM:max-w-[620px] md:max-w-[380px]">
							<img
								src={"/landings/assets/images/casos/assets/brinks/brinks-mockup-mobile.svg"}
								alt=""
								className={cn("z-10 w-full")}
							/>
						</div>
					)}
				</div>

				<img
					src={
						isLaptop
							? "/landings/assets/images/casos/assets/brinks/brinks-texture.svg"
							: "/landings/assets/images/casos/assets/brinks/brinks-texture-mobile.svg"
					}
					alt="GP Cargo - Textura"
					className={cn(
						"absolute",
						["top-0 right-0 w-full h-full object-cover left-0 object-[0_-96px]"],
						[
							"laptop:h-full laptop:w-full laptop:max-w-[50%] laptop:right-0 laptop:top-0 laptop:left-auto laptop:object-[initial]",
						],
					)}
				/>
			</div>
		</section>
	);
}
